import { render, staticRenderFns } from "./_team.vue?vue&type=template&id=21da9bad&scoped=true&lang=pug&"
import script from "./_team.vue?vue&type=script&lang=js&"
export * from "./_team.vue?vue&type=script&lang=js&"
import style0 from "./_team.vue?vue&type=style&index=0&id=21da9bad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21da9bad",
  null
  
)

export default component.exports